import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { iconAgregar, ngClassAceptarModal, ngClassSalirModal, DscTituloPaginator, isNotEmpty, isNotEmptyList, isEmpty, openModalMensaje, StrDscToolTipText, recupToolTipCar, limpiarTexto, strMatTablePaginator } from 'src/app/general/variables';
import { ContratacionHechoIrreg } from 'src/app/models/ContratacionHechoIrreg';
import { FichaXConratacionXHi } from 'src/app/models/FichaXContratacionXHi';
import { MatTableDataSource, MatPaginator, MatSort, MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { element } from 'protractor';
import { HechoIrregularService } from 'src/app/services/hecho-irregular.service.';
import { ObraHechoIrregular } from 'src/app/models/ObraHechoIrregular';

@Component({
  selector: 'app-modal-reg-hechoirre-contr',
  templateUrl: './modal-reg-hechoirre-contr.component.html',
  styleUrls: ['./modal-reg-hechoirre-contr.component.css']
})
export class ModalRegHechoirreContrComponent implements OnInit {

  flgNuevoHi = false;
  strDscHi = '';
  flgViewDscHi = false;
  iconAgregar = iconAgregar;
  isMobile = false;
  strDscTooltip: string = StrDscToolTipText;

  listHechoIrregular: ContratacionHechoIrreg[] = [];
  listaContrXHi: FichaXConratacionXHi[] = [];
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;

  matTableColumnsDef = ['hechoIrregular', 'acciones'];
  matTableColumnsEtiq = ['Tema del presunto hecho irregular', 'Seleccionar'];
  strMatTablePaginator = strMatTablePaginator;
  dataSource: MatTableDataSource<ContratacionHechoIrreg>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(private dialogRef: MatDialogRef<ModalRegHechoirreContrComponent>,
              public dialog: MatDialog,
              protected hechoIrregularService: HechoIrregularService,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    // console.log("===========this.data.listHi");
    // console.log(this.data.listHi);

    let listHI: ObraHechoIrregular[] = [];

    const vListHechoIrregular: FichaXConratacionXHi[] = this.data.listHi;

    if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

    this.navModalC.setDatosNavModal2('Materia del hecho irregular');

    this.hechoIrregularService.ListarHechoIrregular('HI').subscribe(
      data => {

        listHI = data;

        for (let index = 0; index < listHI.length; index++) {

          const contratacionPorHechoIrregular = new ContratacionHechoIrreg();

          contratacionPorHechoIrregular.num_item = index;
          contratacionPorHechoIrregular.flgSeleccionar = false;


          contratacionPorHechoIrregular.ccontrhiDsc = listHI[index].cobrphiDsc;
          contratacionPorHechoIrregular.ncontrhiId = listHI[index].nobrphiId;

          this.listHechoIrregular.push(contratacionPorHechoIrregular);

        }

        this.listHechoIrregular.forEach(hecho => {

          if (isNotEmptyList(vListHechoIrregular)) {

            vListHechoIrregular.forEach(element => {

                if (hecho.ncontrhiId == element.nfichaxcontxhiIdhi) {

                  hecho.flgSeleccionar = true;

                } else if (element.cfichaxcontxhiFlgnuevo == 'SI') {

                  this._cambioFlgNuevoHi(true);
                  this._agregarNewHi(true);

                  this.strDscHi = element.cfichaxcontxhiDschi;


                }

            });

          }


        });

        this._cargarTableMaterial();

      });

    // for(let i = 0; i < 5; i++)
    // {
    //   let contratacionPorHechoIrregular = new ContratacionHechoIrreg();

    //   contratacionPorHechoIrregular.num_item = i;
    //   contratacionPorHechoIrregular.flgSeleccionar = false;


    //   contratacionPorHechoIrregular.ccontrhiDsc = "Hecho Irregular " + (i+1);
    //   contratacionPorHechoIrregular.ncontrhiId = (i+1);

    //   this.listHechoIrregular.push(contratacionPorHechoIrregular);

    // }



  }

  _reemplazarTexto(e) {


    const cleaned = limpiarTexto(e.target.value);

    e.target.value = cleaned;
    this.strDscHi = cleaned;

   }

  _cambioDescripcion() {

    this.strDscTooltip = recupToolTipCar(this.strDscHi);


  }

  _agregarNewHi(flgValor: boolean) {

    this.strDscHi = '';

    this._setFlgViewDscHi(flgValor);

  }

  _setFlgViewDscHi(flgValor: boolean) {

    this.flgViewDscHi = flgValor;

  }

  _cambioFlgNuevoHi(flgValor: boolean) {

    this._setFlgNuevoHi(flgValor);


    if (!flgValor) {this._agregarNewHi(false); }

    // this._setFlgViewDscHi(flgValor);

    // LIMPIAR LISTA Y CAMPO

    this.listHechoIrregular.forEach(hecho => {

      hecho.flgSeleccionar = false;

    });


    // LIMPIAR LISTA Y CAMPO

  }

  _setFlgNuevoHi(flgValor: boolean) {

    this.flgNuevoHi = flgValor;

  }

  _aceptar() {

    let vContrXHi: ContratacionHechoIrreg = null;

    if ((this.listHechoIrregular.filter(x => x.flgSeleccionar == true).length == 0) && isEmpty(this.strDscHi)) {

      openModalMensaje('Hecho Irregular', 'Debe seleccionar por lo menos un hecho irregular o ingresar uno nuevo', this.dialog);

      return;

    }



    if (this.flgNuevoHi) {

      if (isEmpty(this.strDscHi)) {

        openModalMensaje('Hecho Irregular', 'Debe ingresar la descripción de la irregularidad no encontrada', this.dialog);

        return;

      }

      vContrXHi = new ContratacionHechoIrreg();

      vContrXHi.ccontrhiDsc = this.strDscHi;
      vContrXHi.flg_nuevo = 'SI';

      this._insertarListaHi(vContrXHi);

    } else {

      this.listHechoIrregular.forEach(data => {

        if (data.flgSeleccionar) {

          this._insertarListaHi(data);


        }

      });

    }

    // this.data.obraPub.listaFurPorObraPubPorHechoIrr = this.listaObraXHi;

    this.dialogRef.close(this.listaContrXHi);

  }


  _checkSeleccionar(hechoIrregular: ContratacionHechoIrreg, data: any) {

    this.listHechoIrregular.forEach(hecho => {

      if (hecho.ncontrhiId == hechoIrregular.ncontrhiId) {

          hecho.flgSeleccionar = data.target.checked;
      }
    });
  }

  _cerrarModal() {
    this.dialogRef.close();
  }

  _cargarTableMaterial() {
    this.dataSource = new MatTableDataSource(this.listHechoIrregular);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  _insertarListaHi(data: ContratacionHechoIrreg) {

    let contratacionHi: FichaXConratacionXHi = null;

    contratacionHi = new FichaXConratacionXHi();

    // contratacionHi.con = data;
    contratacionHi.nfichaxcontxhiIdhi = data.ncontrhiId;
    contratacionHi.cfichaxcontxhiDschi = data.ccontrhiDsc;
    contratacionHi.cfichaxcontxhiFlgnuevo = data.flg_nuevo;

    this.listaContrXHi.push(contratacionHi);

  }

}

